//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../Drawings/Drawings.SelectDraftingViewList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"TableList",1,0],[0,"ViewPlan",1,0],[0,"ViewScope",1,0],[1,"ViewSelect",0,"Drawings.SelectDraftingViewList",0]],[[["pos"],"SetSelectPoint",{},1,0],[[],"CreateTable",{R_:{table:"Annotations.Table"}},0,0],[[],"DeleteExistTable",{},0,0]],[]];
SPLM.Features.ShipDesign.InteractiveAnnotationTableBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.InteractiveAnnotationTableBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.InteractiveAnnotationTableBuilder.ViewScopeOptions = Object.freeze({
    "ActiveSheet" : "ActiveSheet", "AllSheets" : "AllSheets", "SelectedView" : "SelectedView"});

export default SPLM;